import type React from 'react';
import { ReactSVG } from 'react-svg';
import { useTheme } from '@mui/material/styles';
import {
  IconThumbDown,
  IconThumbUp,
  type IconProps,
} from '@tabler/icons-react';
import { Box } from '@mui/material';
import type { WorkflowConfigArgs } from 'api/types';
import moodHappy from 'assets/icons/quick-feedback/mood-happy.svg';
import moodAngry from 'assets/icons/quick-feedback/mood-angry.svg';
import heartHappy from 'assets/icons/quick-feedback/heart-happy.svg';
import heartAngry from 'assets/icons/quick-feedback/heart-angry.svg';

export const icons = {
  bw_smile: {
    BadIcon: (props: IconProps) => (
      <Box
        component={ReactSVG}
        height='27px'
        src={moodAngry}
        sx={{
          ':focus, :hover': {
            outline: 'none',
            path: { fill: props.fill, stroke: props.color },
          },
          path: { fill: props.fill, stroke: props.color },
        }}
        width='27px'
      />
    ),
    GoodIcon: (props: IconProps) => (
      <Box
        component={ReactSVG}
        height='27px'
        src={moodHappy}
        sx={{
          ':focus, :hover': {
            outline: 'none',
            path: { fill: props.fill, stroke: props.color },
          },
          path: { fill: props.fill, stroke: props.color },
        }}
        width='27px'
      />
    ),
  },

  hearts: {
    BadIcon: (props: IconProps) => (
      <Box
        component={ReactSVG}
        height='27px'
        src={heartAngry}
        sx={{
          ':focus, :hover': {
            outline: 'none',
            path: { fill: props.fill, stroke: props.color },
          },
          path: { fill: props.fill, stroke: props.color },
        }}
        width='27px'
      />
    ),
    GoodIcon: (props: IconProps) => (
      <Box
        component={ReactSVG}
        height='27px'
        src={heartHappy}
        sx={{
          ':focus, :hover': {
            outline: 'none',
            path: { fill: props.fill, stroke: props.color },
          },
          path: { fill: props.fill, stroke: props.color },
        }}
        width='27px'
      />
    ),
  },

  thumbs: {
    BadIcon: IconThumbDown,
    GoodIcon: IconThumbUp,
  },
} as const satisfies Record<
  WorkflowConfigArgs['quick_feedback_config']['style'],
  {
    BadIcon: (props: IconProps) => React.ReactNode;
    GoodIcon: (props: IconProps) => React.ReactNode;
  }
>;

export function useStyles() {
  const theme = useTheme();

  return {
    badStyles: {
      color: theme.palette.colors.red[500],
      fill: theme.palette.colors.red[100],
    },

    goodStyles: {
      color: theme.palette.colors.green[500],
      fill: theme.palette.colors.green[100],
    },
  } as const satisfies {
    badStyles: IconProps;
    goodStyles: IconProps;
  };
}
